import formatStructureType from "@/utils/formatStructureType";
import { ProjectStructureType } from "@/web-client/api";

interface IStructureType {
  id: ProjectStructureType;
  label: string;
}

export const StructureTypes: IStructureType[] = [
  ProjectStructureType.WOODEN,
  ProjectStructureType.STEEL,
  ProjectStructureType.REINFORCED_CONCRETE,
  ProjectStructureType.STEEL_REINFORCED_CONCRETE,
  ProjectStructureType.MASONRY,
  ProjectStructureType.MIX,
  ProjectStructureType.OTHER,
].map((value) => {
  return { id: value, label: formatStructureType(value) };
});
